import '@/serviceWorker';
import '@/utils/httpProxy';
import '@/utils/polyfill';

import Vue from 'vue';
import GlobalComponents from '@/components/global';
import { preloadImg } from '@/utils/preload';
import { loadHbridge } from '@/utils/globalLoader';
import App from '@/App';
import store from '@/store';
import router from '@/router';
import plugins from '@/plugins';
import images from '@/const/images';
import { Toast } from 'vant';

const { onerror } = window;
window.onerror = function _(errorMessage, scriptURI, lineNumber, columnNumber, error) {
  // console.log('错误信息：', errorMessage);
  // console.log('出错文件：', scriptURI);
  // console.log('出错行号：', lineNumber);
  // console.log('出错列号：', columnNumber);
  // console.log('错误详情：', error);
  if (process.env.VUE_APP_ENV !== 'pro') {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  const { TianQiApm } = window;
  if (TianQiApm) TianQiApm.APM.sendError(error);

  if (onerror && typeof onerror === 'function') {
    onerror.call(window, errorMessage, scriptURI, lineNumber, columnNumber, error);
  }
  return true;
};
Vue.config.errorHandler = (error) => {
  if (process.env.VUE_APP_ENV !== 'pro') {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  const { TianQiApm } = window;
  if (TianQiApm) TianQiApm.APM.sendError(error);
};

Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV !== 'pro') {
  Vue.config.devtools = true;
  // eslint-disable-next-line no-console
  console.log('__build_params_appVersio: ', window.__build_params_appVersion);
}

Vue.use(store);
Vue.use(plugins);
Vue.use(GlobalComponents);

export default new Vue({
  el: '#app',
  router,
  store,
  mounted: () => {

  },
  render: (h) => h(App),
});


if (!window.__PRERENDER_INJECTED) {
  store.dispatch('location/getLocation');
  store.dispatch('user/getUserInfo');
}

// 预加载图片资源但这些图片资源并不是所有页面都会用到
// 如果首次加载页面是 /one-yuan-welfare-card/buy 页面，则不预加载图片资源
// 预加载的图片资源 /one-yuan-welfare-card/buy 页面用不到，但占带宽
const isOneYuanWelfareCardBuy = window.location.hash.startsWith('#/one-yuan-welfare-card/buy');
if (!isOneYuanWelfareCardBuy && !window.__PRERENDER_INJECTED) {
  preloadImg(...Object.values(images));
}

loadHbridge().then(async (r) => {
  const { env } = r;

  if (env.isEasyBikeApp && env.isIOS) {
    // 解决ios手机收起键盘时，顶部元素丢失bug
    document.body.addEventListener('focusout', () => {
      window.scrollTo(0, 0);
    });
  }

  if (env.isEasyBikeApp) {
    // 哈啰出行 APP
    const version = env.appVersion;
    if (version < '5.77.0') {
      Toast({
        message: '您当前的版本过低，请先升级版本后再使用',
        duration: 1000,
      });
    }
  }
});
